import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { I18n } from 'react-redux-i18n';
import queryString from 'query-string';
import themeConfig from '../theme-config';
import { auth, authFromRedirect } from '../redux/actions/authActions';
import Loading from '../components/util/Loading';
import { showToast } from '../redux/actions/toastrActions';
import store from '../store';
import { SHOW_LOADING, HIDE_LOADING } from '../redux/actions/types/loadingTypes';

const styles = theme => ({

  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },

  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
});

class LoginPage extends React.Component {
  constructor(props) {

    super(props);
    this.onLoginButtonClick = this.onLoginButtonClick.bind(this);

    this.state = {
      username: '',
      password: '',
    };

  }

  handleChange = name => (event) => {

    this.setState({
      [name]: event.target.value,
    });

  };

  onLoginButtonClick(event) {

    const { auth, history } = this.props;
    const { username, password } = this.state;
    event.preventDefault();

    store.dispatch({
      type: SHOW_LOADING,
    });


    auth({
      usuario: username,
      senha: password,
    }).then(() => {

      store.dispatch({
        type: HIDE_LOADING,
      });

      history.push('/context');

    }, (e) => {

      store.dispatch({
        type: HIDE_LOADING,
      });
      showToast('error', '', 'Credenciais Inválidas');

    });

  }

  isValid() {

    return this.state.username.length && this.state.password.length > 3;

  }

  handleKeyPress = (event) => {

    if (event.key === 'Enter') this.onLoginButtonClick(event);

  }

  componentDidMount() {

    localStorage.setItem('last_path', window.location.pathname !== '/login' ? window.location.pathname : '/clinicas');

    if (this.props.location) {

      const query = queryString.parse(this.props.location.search);

      if (query.usuario && query.bearer) this.redirectLogin(query.usuario, query.bearer);

    }

  }


  render() {


    const { username, password } = this.state;
    const { classes, loading } = this.props;

    return (
      <div>
        { loading
            && <Loading />
            }
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <center>
              <img style={{ width: '100%' }} src={themeConfig.logo} alt="logo" />
            </center>
            <form className={classes.form}>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="username">{I18n.t('fields.username')}</InputLabel>
                <Input
                  id="username"
                  name="username"
                  autoComplete="username"
                  autoFocus
                  onChange={this.handleChange('username')}
                  onKeyPress={this.handleKeyPress}
                />
              </FormControl>
              <FormControl margin="normal" required fullWidth>
                <InputLabel htmlFor="password">{I18n.t('fields.password')}</InputLabel>
                <Input
                  name="password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  onChange={this.handleChange('password')}
                  onKeyPress={this.handleKeyPress}
                />
              </FormControl>
              <Button
                type="submit"
                fullWidth
                variant="raised"
                color="primary"
                onClick={this.onLoginButtonClick}
                className={classes.submit}
              >
                {I18n.t('button.login')}
              </Button>
              <center>
                <a href="">{I18n.t('button.forgot_password')}</a>
              </center>
              <center>
                <a href="mailto: operacoes@tribosoftware.com.br" style={{ fontSize: '0.8em' }}>
                  Contato
                </a>
              </center>
            </form>
          </Paper>
        </main>
      </div>

    );

  }


}


LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  user: state.auth.user,
  loading: state.appReducer.loading,
});

const mapDispatchToProps = {
  auth,
  authFromRedirect,
};


const connectedContainer = connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LoginPage));
const RoutedContainer = withRouter(connectedContainer);
export default RoutedContainer;



// WEBPACK FOOTER //
// ./src/containers/LoginPage.js